/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingImageFixedSizeQueryResponse, GetDrawingImageFixedSizePathParams, GetDrawingImageFixedSizeQueryParams, GetDrawingImageFixedSize400, GetDrawingImageFixedSize401, GetDrawingImageFixedSize403, GetDrawingImageFixedSize404, GetDrawingImageFixedSize422 } from "../models/drawingClient/GetDrawingImageFixedSize";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingImageFixedSizeUrl(project_uuid: GetDrawingImageFixedSizePathParams["project_uuid"], file_uuid: GetDrawingImageFixedSizePathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/img` as const }  
  return res
}

/**
 * @description Returns an image which is represented as a dataurl containing a PNG file of the drawing with its extent as a JSON object.
 * @summary Get an image of a drawing
 * {@link /v1/drawings/:project_uuid/:file_uuid/img}
 */
export async function getDrawingImageFixedSize(project_uuid: GetDrawingImageFixedSizePathParams["project_uuid"], file_uuid: GetDrawingImageFixedSizePathParams["file_uuid"], params?: GetDrawingImageFixedSizeQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingImageFixedSizeQueryResponse, ResponseErrorConfig<GetDrawingImageFixedSize400 | GetDrawingImageFixedSize401 | GetDrawingImageFixedSize403 | GetDrawingImageFixedSize404 | GetDrawingImageFixedSize422>, unknown>({ method : "GET", url : getGetDrawingImageFixedSizeUrl(project_uuid, file_uuid).url.toString(), params, ... requestConfig })  
  return res.data
}